import * as React from "react";
import { ScaleLoader } from "react-spinners";
import styles from "./Button.scss";

interface IProps {
    id: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    children?: React.ReactNode[] | React.ReactNode;
    isLoading?: boolean;
    disabled?: boolean;
}

const Button: React.FunctionComponent<IProps> = (props: IProps) => (
    <button id={props.id} onClick={props.onClick} disabled={props.disabled}>
        {props.children}
        <div className={`${styles.loader} ${props.isLoading ? styles.show : ""}`}>
            <ScaleLoader color="#364C59" height={10} width={2} />
        </div>
    </button>
);

export default Button;


// WEBPACK FOOTER //
// ./src/Components/Common/Button/Button.tsx